import { md } from '@/utils/utils_html';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { format_timestamp_YY_MM_DD_HH_mm_ss } from '@shared/utils/utils_time';
import { UserAvatarReadOnly } from '../../_base/UserAvatarReadOnly';
import { WSButtonWorkspaceUserDelete } from './buttons/WSButtonWorkspaceUserDelete';
import { WSButtonWorkspaceUserTransferOwnershipCreate } from './buttons/WSButtonWorkspaceUserTransferOwnershipCreate';
import { WSButtonWorkspaceUserTransferOwnershipRevoke } from './buttons/WSButtonWorkspaceUserTransferOwnershipRevoke';

interface Props {
  item: DTO__workspace_user;
}

export const WTableUsersRow = ({ item }: Props) => {
  return (
    <div className={`${md('px-2 justify-between', 'gap-5 pr-5 justify-start')} w-full min-h-[50px] flex flex-row items-center `}>
      <span className={`${md('w-[45px] text-[9px]', 'w-[100px]')} flex items-center justify-center`}>
        <UserAvatarReadOnly url_relative={item.url_relative_avatar} userName={item.full_name} className="!min-w-9 !min-h-9" />
      </span>
      <span className={`${md('w-[45px] text-[9px]', 'w-[150px]')}  text-left`}>{item.full_name}</span>
      <span className={`${md('w-[45px] text-[9px]', 'w-[200px]')}  text-left`}>{format_timestamp_YY_MM_DD_HH_mm_ss(item.created_at)}</span>
      <span className={`${md('w-[45px] text-[9px]', 'w-[200px]')}  text-left`}>{format_timestamp_YY_MM_DD_HH_mm_ss(item.last_online_at)}</span>
      <WSButtonWorkspaceUserTransferOwnershipCreate item={item} />
      <WSButtonWorkspaceUserTransferOwnershipRevoke item={item} />
      <WSButtonWorkspaceUserDelete item={item} />
    </div>
  );
};
